// frontend/src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  FaTwitter,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer
      className="
        bg-blue-900 text-gray-300 pt-8 md:pt-12
        dark:bg-black dark:text-white
      "
      role="contentinfo"
    >
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 lg:px-12">
        {/* Links grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {/* Column 1: About */}
          <div>
            <h4
              className="
                text-lg md:text-2xl font-bold text-white mb-2.5 md:mb-3
                dark:text-white
              "
            >
              Coinzetto
            </h4>
            <p
              className="
                text-xs md:text-sm text-gray-300 mb-3 md:mb-4 leading-relaxed
                dark:text-white/80
              "
            >
              Empower your crypto journey with Coinzetto, the simple and secure
              crypto exchange platform.
            </p>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/about"
                  className="
                    text-xs md:text-sm hover:text-white
                    dark:text-[#7aa2ff] dark:hover:text-white
                  "
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="
                    text-xs md:text-sm hover:text-white
                    dark:text-[#7aa2ff] dark:hover:text-white
                  "
                >
                  Careers
                </Link>
              </li>
              <li>
                <Link
                  to="/partners"
                  className="
                    text-xs md:text-sm hover:text-white
                    dark:text-[#7aa2ff] dark:hover:text-white
                  "
                >
                  Partners
                </Link>
              </li>
              <li>
                <Link
                  to="/corporate-account"
                  className="
                    text-xs md:text-sm hover:text-white
                    dark:text-[#7aa2ff] dark:hover:text-white
                  "
                >
                  Corporate Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Markets & Trade */}
          <div>
            <h4
              className="
                text-lg md:text-2xl font-bold text-white mb-2.5 md:mb-3
                dark:text-white
              "
            >
              Markets & Trade
            </h4>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/markets"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Markets Overview
                </Link>
              </li>
              <li>
                <Link
                  to="/trade"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Trade
                </Link>
              </li>
              <li>
                <Link
                  to="/fees"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Fees
                </Link>
              </li>
              <li>
                <Link
                  to="/api-docs"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  API Documentation
                </Link>
              </li>
              <li>
                <Link
                  to="/download"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Download
                </Link>
              </li>
              <li>
                <Link
                  to="/trade-contest"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Trade Contest
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Learn & Support */}
          <div>
            <h4
              className="
                text-lg md:text-2xl font-bold text-white mb-2.5 md:mb-3
                dark:text-white
              "
            >
              Learn & Support
            </h4>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/learn"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Learn Overview
                </Link>
              </li>
              <li>
                <Link
                  to="/trade-smart"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Trade Smart
                </Link>
              </li>
              <li>
                <Link
                  to="/glossary"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Glossary
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/white-paper"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  White Paper
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Support Ticket
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Legal & Policies */}
          <div>
            <h4
              className="
                text-lg md:text-2xl font-bold text-white mb-2.5 md:mb-3
                dark:text-white
              "
            >
              Legal & Policies
            </h4>
            <ul className="space-y-1">
              <li>
                <Link
                  to="/terms"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/aml-kyc"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  AML / KYC
                </Link>
              </li>
              <li>
                <Link
                  to="/refund-policy"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/list-crypto"
                  className="text-xs md:text-sm hover:text-white dark:text-[#7aa2ff] dark:hover:text-white"
                >
                  List Crypto
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Icons */}
        <div className="mt-8 md:mt-10 flex justify-center space-x-4 md:space-x-6 text-xl md:text-2xl">
          <a
            href="https://twitter.com/coinzetto"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
            className="
              text-gray-300 hover:text-white transition-colors
              dark:text-white/80 dark:hover:text-white
            "
          >
            <FaTwitter />
          </a>
          <a
            href="https://facebook.com/coinzetto"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="
              text-gray-300 hover:text-white transition-colors
              dark:text-white/80 dark:hover:text-white
            "
          >
            <FaFacebookF />
          </a>
          <a
            href="https://instagram.com/coinzetto"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="
              text-gray-300 hover:text-white transition-colors
              dark:text-white/80 dark:hover:text-white
            "
          >
            <FaInstagram />
          </a>
          <a
            href="https://linkedin.com/company/coinzetto"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="
              text-gray-300 hover:text-white transition-colors
              dark:text-white/80 dark:hover:text-white
            "
          >
            <FaLinkedinIn />
          </a>
          <a
            href="https://youtube.com/coinzetto"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="
              text-gray-300 hover:text-white transition-colors
              dark:text-white/80 dark:hover:text-white
            "
          >
            <FaYoutube />
          </a>
        </div>

        {/* Bottom Area */}
        <div
          className="
            mt-6 md:mt-8 border-t border-gray-700 pt-4 md:pt-6 text-center text-xs md:text-sm text-gray-500
            dark:border-neutral-800 dark:text-white/70
          "
        >
          <p>© {new Date().getFullYear()} Coinzetto. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
